export default __webpack_public_path__ + "static/form3-670b21e9b3d246d964f55e8390363211.svg";